var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3941",
    width: 113.845,
    height: 72.877,
    viewBox: "0 0 30.121 19.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs3935"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath1171",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1173",
    d: "m296.894 4.018-85.992 36.758 16.947 18.852 69.143.497z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26458299px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5413-3",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5415-1",
    d: "m321.282 88.37-28.607 17.725 126.914 46.568.046-64.292z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".37320301px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath6722-6",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6724-2",
    d: "m.19 64.296 87.723 25.276 110.118-30.825L227.939.317.26.19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".37119201px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7131-9",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7133-1",
    d: "m.19 64.296 87.723 25.276 110.118-30.825L227.939.317.26.19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".37119201px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5561-9",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5563-9",
    d: "m150.18 155.291 135.755-41.667 116.6 42.003z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".37400201px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5413-5",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5415-9",
    d: "m321.282 88.37-28.607 17.725 126.914 46.568.046-64.292z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".37320301px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath5096-2",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5098-0",
    d: "m95.88 94.83 105.68-29.743 93.78-3.15 21.709 23.788-31.506 18.904L146.62 149.07Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26458299px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath3047-6",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3049-9",
    d: "M.239 75.375 87.94 98.561l54.436 56.788-142.186-.09Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".37400201px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath2877-4",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2879-6",
    d: "m235.864.293-30.296 58.55 89.783-4.904L419.795.284Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".37400201px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath2378-9",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2380-2",
    d: "M419.87 9.366 300.44 59.213l18.376 22.42 100.99-.188Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".37964499px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7661",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7659",
    d: "M0 156.606h244.642V0H0Z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7723",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7721",
    d: "M0 841.89h595.28V0H0Z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7731",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7729",
    d: "M0 841.89h595.28V0H0Z"
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7761",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7759",
    d: "M229.403 413.35h188.725v29.032H229.403Z"
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7771",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7769",
    d: "M0 841.89h595.28V0H0Z"
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7723-8",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7721-8",
    d: "M0 841.89h595.28V0H0Z"
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7731-7",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7729-9",
    d: "M0 841.89h595.28V0H0Z"
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7761-1",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7759-6",
    d: "M229.403 413.35h188.725v29.032H229.403Z"
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath7771-5",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7769-2",
    d: "M0 841.89h595.28V0H0Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8584",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8586",
    d: "M152.4 470.463h273.397l5.208-88.528-275.133-2.604z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".82973498px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9431",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9429",
    d: "M0 0h596v192H0Z"
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath9441",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9439",
    d: "M0 0h596v192H0Z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath10167",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path10169",
    d: "M16.468 1.036C23.438 2.108 178.403.5 178.403.5l1.072 131.907H15.931Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".99999899px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15782",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path15784",
    d: "m.19 64.296 87.723 25.276 110.118-30.825L227.939.317.26.19Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".37119201px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath15786",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path15788",
    d: "m92.994 92.544 105.994-30.163 98.729.116 18.358 20.99-122.742 76.151-40.652.217z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".262761px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath16043",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16045",
    d: "m231.683.294-30.435 59.063 95.978-.35L419.934 6.701 419.854 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26592201px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath16427",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16429",
    d: "M419.87 10.247 300.803 61.242l18.013 20.39 100.99-.187Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".37964499px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17132",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path17134",
    d: "M-.047 67.183 87.05 92.435l60.034 67.455-147.18-.093Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".37888601px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17154",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path17156",
    d: "m199.384 159.8 91.251-56.246L419.9 136.87v23.105z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".26458299px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath17470",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path17472",
    d: "m319.29 84.262-25.993 16.853 126.616 32.738-.278-49.716z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".37320301px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-104.849 -253.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1-5",
    style: {
      opacity: 1
    },
    transform: "translate(-104.086 76.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10294",
    transform: "translate(-29.577 1.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7657",
    clipPath: "url(#clipPath7661)",
    transform: "matrix(.12312 0 0 -.12312 238.512 194.827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g7663",
    transform: "translate(0 156.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7665",
    d: "M0 0h228.864s15.778 1.306 15.778-16.882v-139.704H0Z",
    style: {
      fill: "#b20d35",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "path7667",
    d: "M111.906 104.881H80.901v31.005h31.005z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7669",
    d: "M11.768 79.038h13.739v5.479H11.768Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g7671",
    transform: "translate(24.779 20.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7673",
    d: "M0 0V101.379s-1.316 13.779 13.168 13.779h37.425v-5.42H40.581s-9.639.429-9.639-9.943V0Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g7675",
    transform: "translate(61.235 84.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7677",
    d: "M0 0h147.874s15.195 1.287 15.195-14.379v-49.065h-30.782v48.238s.154 9.814-9.433 9.814h-15.83v-58.052H76.05v48.228s.208 9.987-9.431 9.987H50.651v-58.5H19.606v58.337H-.001Z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "path19255",
    cx: 407.715,
    cy: 185.608,
    r: 0.059,
    style: {
      fill: "#000",
      stroke: "#000",
      strokeWidth: 0.26458299
    }
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style4",
    type: "text/css"
  }, ".st3{fill:#208e9c}.st4{fill:#8e3547}.st5{fill:#56656c}.st6{fill:#008cb3}.st0{fill:#fff}.st1{fill:#f8d200}.st2{fill:#e30613}")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFim);
export default __webpack_public_path__ + "static/media/fim.e59e36cf5d3d79349e13318371475139.svg";
export { ForwardRef as ReactComponent };